export function initAccordion(){
    $('.card-link').on("click", function (e) {
        if($($(this).attr('href')).hasClass("show")){
            $('.collapsed.top-collapse').click();
        }
    });
};